import { IotSuspense } from "@core/presentation/components/feedback/suspense/iot-suspense.component";
import { IotTypography } from "@core/presentation/components/general/typography/iot-typography.component";
import { IotLayout } from "@core/presentation/components/layout/layout/iot-layout.component";
import { useEnvironment } from "@core/presentation/hook/use-environment/use-environment.hook.ts";
import { useDidMount } from "@iot-platform/core";
import { App } from "antd";
import { observer } from "mobx-react";
import type { FC } from "react";
import { Outlet } from "react-router";

export const DashboardLayout: FC = observer(() => {
    const { notification } = App.useApp();
    const env = useEnvironment();

    useDidMount(() => {
        if (env.isDevelopment) {
            notification.info({
                message: "API Development Mode",
                description: env.mockApiEnabled ? (
                    <IotTypography.Text
                        className={"tw:text-yellow-600 tw:font-bold"}
                        // eslint-disable-next-line i18next/no-literal-string
                    >
                        You are using the mock API
                    </IotTypography.Text>
                ) : (
                    <IotTypography.Text
                        className={"tw:text-green-600 tw:font-bold"}
                        // eslint-disable-next-line i18next/no-literal-string
                    >
                        You are using the real API
                    </IotTypography.Text>
                ),
                duration: 10,
                showProgress: true,
            });
        }
    });

    return (
        <IotLayout className={"tw:min-h-[100vh]"}>
            <IotSuspense>
                <Outlet />
            </IotSuspense>
        </IotLayout>
    );
});

DashboardLayout.displayName = "DashboardLayout";
